export const defaultValuesForm = {
  approvalType: { value: 1, label: 'Tukar Jadwal' },
  reason: '',
  files: [],
  host: null,
  liveAccount: '',
  hostChangeHost: null,
  targetScheduleId: null,
  scheduleDate: '',
};
